import { defineMessages } from 'react-intl';

export const paymentMethodIds = {
  mandate: 'mandate',
  ideal: 'ideal',
  onAccount: 'onAccount',
  creditCard: 'creditCard',
  bcmc_mobile: 'bcmc_mobile',
  paypal: 'paypal',
  bcmc: 'bcmc',
};

export const paymentMethodMessages = defineMessages({
  mandate: {
    id: 'checkout.paymentmethod.mandate',
    defaultMessage: 'Mandate',
  },
  creditcard: {
    id: 'checkout.paymentmethod.creditcard',
    defaultMessage: 'CreditCard',
  },
  onaccount: {
    id: 'checkout.paymentmethod.onaccount',
    defaultMessage: 'Pay afterwards on account',
  },
  ideal: {
    id: 'checkout.paymentmethod.ideal',
    defaultMessage: 'iDEAL',
  },
  paypal: {
    id: 'checkout.paymentmethod.paypal',
    defaultMessage: 'PayPal',
  },
  bcmc: {
    id: 'checkout.paymentmethod.bcmc',
    defaultMessage: 'Ban Contact Mister Cash',
  },
  bcmc_mobile: {
    id: 'checkout.paymentmethod.bcmc_mobile',
    defaultMessage: 'Ban Contact Mister Cash mobile',
  },
});

export const getPaymentInfo = (customLineItems) =>
  customLineItems
  && customLineItems.find((customLineItem) => customLineItem.slug.includes('payment-method'));

export const getPaymentMethod = (paymentInfo) => {
  const lastPayment = [...paymentInfo.payments].pop();
  return lastPayment ? lastPayment.obj.paymentMethodInfo.method : '';
};

export const getMandateId = (paymentInfo) => {
  const mandatePayment = paymentInfo.payments.find((payment) => payment.obj.custom.fields.mandateId);
  return mandatePayment.obj.custom.fields.mandateId;
};
